// Props for a react-select that sits above a table with a sticky header.
//
// The header is sticky and carries z-10 so the rows scroll under it. A dropdown opened in the
// filter row above renders inside the page flow, so the header painted over the top of it and ate
// the first option or two -- the ones you reach for most.
//
// Portalled to document.body rather than raised with a z-index alone. A z-index only ranks
// siblings within the same stacking context, and the header and the menu are not siblings; the
// portal takes the menu out of the page's stacking altogether, where a z-index above everything
// else on the screen means what it says. It is what MenuCreationForm's item picker already does.
//
// Spread onto the Select: <Select {...menuAboveTable} ... />. Add `styles` of your own after the
// spread and merge menuPortal back in, or the portal loses its z-index.
export const menuAboveTable = {
    menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
    styles: {
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    },
};

// The same, for a Select that already has styles of its own. Spreading menuAboveTable and then
// setting `styles` would drop the portal's z-index -- a portalled menu with the default z-index
// of 1 can end up behind the very thing it was lifted out of -- so the two are merged here.
//
//     <Select {...menuAboveTable} styles={withMenuOnTop(customStyles)} ... />
export const withMenuOnTop = (styles) => ({
    ...(styles ?? {}),
    menuPortal: (base, state) => ({
        ...((styles?.menuPortal?.(base, state)) ?? base),
        zIndex: 9999,
    }),
});
